import { faEnvelope, faLock, faMobileScreen, faUser, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoAndText from '../components/LogoAndText';
import { Link } from 'react-router-dom';
import { userSignUp } from '../apiServices/apiServices';
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CustomToastContainer from '../components/CustomToastContainer';
import { generateOtpMethod } from '../utils/otpUtils';

export default function SignUpForm() {
  const navigate = useNavigate();
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
  setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(password !== confirmPassword){
      toast.error('Passwords do not match.');
      return;
    }

    const data = {
      fullname,
      email,
      phone,
      password
    };
      
    try {
      const response = await userSignUp(data);
      // console.log("Response : ", response);
      if (response && response.success) {
        // console.log("Data", response?.data?.passenger);
        // toast.success('Account Created. Verify Otp.');
        const generateOtpRequest = { id: response?.data?.passenger?.id, isSignUp: true };
        generateOtpMethod(generateOtpRequest);

        navigate('/verifyotp', { state: { data: response?.data?.passenger, isSignUp: true } });
      } else {
        toast.error(response.message || 'SignUp failed');
      }
    } catch (error) {
      // console.error('Error signing up:', error);
      toast.error('An error occurred. Please try again.');
    }
  };

  return (
    <>
      <div className="bg-gray-100 flex flex-col items-center justify-center h-screen p-4 md:p-10">
        <div className="w-full md:w-1/2 py-10 md:py-20">
          <div className='mb-10'>
            <LogoAndText/>
          </div>

          <h1 className="text-gray-600 font-semibold text-md md:text-lg text-center mb-6">
            Create Account
          </h1>
          <div className="flex justify-center">
            <form className="w-full sm:w-3/4 md:w-1/2" id="myForm" onSubmit={handleSubmit}>
              <div className="mb-6">
                <div className="relative z-0 w-full mb-5 group">
                  <FontAwesomeIcon icon={faUser} className="absolute text-[#BE1F18] left-0 top-3" />
                  <input
                    type="text"
                    name="fullName"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    id="floating_full_name"
                    className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                    placeholder=" "
                    required
                  />
                  <label
                    htmlFor="floating_full_name"
                    className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Full Name
                  </label>
                </div>
              </div>
              <div className="mb-6">
                <div className="relative z-0 w-full mb-5 group">
                  <FontAwesomeIcon icon={faEnvelope} className="absolute text-[#BE1F18] left-0 top-3" />
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    id="floating_email"
                    className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                    placeholder=" "
                    required
                  />
                  <label
                    htmlFor="floating_email"
                    className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Email
                  </label>
                </div>
              </div>
              <div className="mb-6">
                <div className="relative z-0 w-full mb-5 group">
                  <FontAwesomeIcon icon={faMobileScreen} className="absolute text-[#BE1F18] left-0 top-3" />
                  <input
                    type="text"
                    name="phoneNumber"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    id="floating_phone_number"
                    className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                    placeholder=" "
                    required
                  />
                  <label
                    htmlFor="floating_phone_number"
                    className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Phone Number
                  </label>
                </div>
              </div>
              <div className="relative z-0 w-full mb-6 group">
                <FontAwesomeIcon icon={faLock} className="absolute text-[#BE1F18] left-0 top-3" />
                <input
                  type={isPasswordVisible ? "text" : "password"}                                     
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  id="floating_password"
                  className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="floating_password"
                  className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Password
                </label>
                <FontAwesomeIcon
                  icon={isPasswordVisible ? faEyeSlash : faEye}
                  onClick={togglePasswordVisibility}
                  className="absolute text-[#BE1F18] right-0 top-3 cursor-pointer"
                />
              </div>
              <div className="relative z-0 w-full mb-6 group">
                <FontAwesomeIcon icon={faLock} className="absolute text-[#BE1F18] left-0 top-3" />
                <input
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  id="floating_confirm_password"
                  className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="floating_confirm_password"
                  className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Confirm Password
                </label>
                <FontAwesomeIcon
                  icon={isConfirmPasswordVisible ? faEyeSlash : faEye}
                  onClick={toggleConfirmPasswordVisibility}
                  className="absolute text-[#BE1F18] right-0 top-3 cursor-pointer"
                />
              </div>
              <button
                type="submit"
                className="bg-[#BE1F18] text-white hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center"
              >
                Sign Up
              </button>
              <h1 className="text-gray-600 font-semibold text-xs md:text-sm text-center mt-2">
                Or
              </h1>
              <Link
                  to="/login"
                className="mt-2 text-[#BE1F18] border border-[#BE1F18] focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center block"
              >
                Login
              </Link>
            </form>
          </div>
        </div>
      </div>
      <CustomToastContainer/>
    </>
  );
}
